import React from "react";
import "./blogpage.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Blogs from "../../components/Blogs/Blogs";

const BlogPage = () => {
    return (
        <>
            <Topbar />
            <div className="BlogPage-container">
                <Blogs />
                <Footer />
            </div>
        </>
    )
}

export default BlogPage;